import { createAction } from 'redux-actions'

export const handleExternalRedirectQuery = createAction(
  'ROUTER/HANDLE_EXTERNAL_REDIRECT_QUERY',
  (query: object) => query
)

export const runRedirectProcess = createAction('ROUTER/RUN_REDIRECT_PROCESS')
